'use client';

import { ClassVideoListItem } from '@/components/class';
import type { ClassVideoContent } from './data';

const parseDurationToSeconds = (duration?: string) => {
  if (!duration) return undefined;

  const parts = duration.split(':').map(part => Number.parseInt(part, 10));

  if (parts.some(part => Number.isNaN(part))) {
    return undefined;
  }

  if (parts.length === 3) {
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }

  if (parts.length === 2) {
    const [minutes, seconds] = parts;
    return minutes * 60 + seconds;
  }

  if (parts.length === 1) {
    return parts[0];
  }

  return undefined;
};

interface ClassVideoItemProps {
  video: ClassVideoContent;
  hidePlayIcon?: boolean;
}

export const ClassVideoItem = ({
  video,
  hidePlayIcon = false,
}: ClassVideoItemProps) => {
  const resolvedDurationSeconds =
    typeof video.durationSeconds === 'number'
      ? video.durationSeconds
      : (parseDurationToSeconds(video.duration) ?? 0);

  const resolvedStatus =
    video.status ??
    (video.isPreview
      ? 'playing'
      : resolvedDurationSeconds === 0
        ? 'comingSoon'
        : 'unwatched');

  return (
    <ClassVideoListItem
      title={video.title}
      durationSeconds={resolvedDurationSeconds}
      status={resolvedStatus}
      progressSeconds={video.progressSeconds}
      onClick={video.onClick}
      onPlayClick={video.onPlayClick}
      disabled={video.disabled}
      hidePlayIcon={hidePlayIcon}
    />
  );
};
